import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';

export const CODIGO_CATEGORIA_SEM_VAGAS_FILA_DESLIGADA = 'CATEGORIA_SEM_VAGAS_FILA_DESLIGADA';

export interface InscricaoErroModalProps {
  open: boolean;
  codigo?: string;
  mensagem?: string;
  onClose: () => void;
}

function mensagemPorCodigo(codigo: string | undefined, fallback: string | undefined): string {
  if (codigo === CODIGO_CATEGORIA_SEM_VAGAS_FILA_DESLIGADA) {
    return 'Esta categoria está com vagas esgotadas e a fila de espera está desativada. A inscrição não pôde ser concluída.';
  }
  return fallback || 'Erro ao realizar inscrição. Tente novamente.';
}

/**
 * Modal de erro de inscrição. Substitui o `alert alert-danger` inline
 * de `TournamentInscriptionCheckout.tsx`. Diferencia mensagem por
 * `codigo` (vindo de `InscricaoNaoPermitidaException.getCodigo()` no backend
 * via `extensions.code`).
 */
export const InscricaoErroModal: React.FC<InscricaoErroModalProps> = ({
  open,
  codigo,
  mensagem,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Erro na inscrição</DialogTitle>
      <DialogContent>
        <DialogContentText>{mensagemPorCodigo(codigo, mensagem)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InscricaoErroModal;
